var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4735 10.4738C15.3531 11.7736 15.1596 12.8298 14.9241 13.7723C14.7671 14.7147 13.8253 15.5 12.8049 15.5H11.5491C10.8427 15.5 10.2933 14.9503 10.2933 14.2435V11.0236C10.2933 10.2382 9.66537 9.60995 8.88049 9.60995H7.07525C6.29036 9.60995 5.66246 10.2382 5.66246 11.0236V14.2435C5.66246 14.9503 5.11304 15.5 4.40664 15.5H2.91535C1.895 15.5 1.03163 14.7932 0.796163 13.7723C0.560697 12.7513 0.356542 11.7745 0.246742 10.4738C0.107394 8.82304 0.246742 7.25393 0.325231 6.23298C0.325231 5.60471 0.717674 4.97644 1.26709 4.58377L6.7613 0.89267C7.07525 0.657068 7.46769 0.5 7.86014 0.5C8.25258 0.5 8.72351 0.657068 9.03747 0.89267L14.5317 4.58377C15.0811 4.97644 15.4735 5.60471 15.4735 6.23298C15.552 7.25393 15.6263 8.82445 15.4735 10.4738Z",
    fill: "#666C95"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.9c75892d.svg";
export { ForwardRef as ReactComponent };